import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';
import { PasswordConfigurationPopUpComponent } from './password-configuration-pop-up/password-configuration-pop-up.component';
import { CommonService } from 'src/app/shared/services/common.service';
import { Actionbutton } from 'src/app/shared/common/Actionbutton';
import { filter } from 'rxjs';
import { UserRoutingModule } from '../user-routing/user-routing.module';
import { ReportlinksserviceService } from '../reportlinks/reportlinksservice.service';

@Component({
    selector: 'app-password-configuration',
    templateUrl: './password-configuration.component.html',
    styleUrls: ['./password-configuration.component.scss'],
    standalone: false
})
export class PasswordConfigurationComponent implements OnInit {
 gridAPI;
gridReadParam;
gridColumnAPI;
lastPage;
currentPage;
nextPage;
nextPagePlusOne;
totalPages;
gridColumnAPIDispatch;
columnDefs;
rowData;
rowClassRules;
defaultColDef;
rowSelection;
paginationPageSize;
paginationNumberFormatter;
pageSize;
components;
gridOptions
  getData: any[];
  backgroundColorButton: string;
  backgroundColorScreen: any;
  passwordPolicy={
    disableallrules:"",retrylimit:"",lastpasswordchecking:"",passwrodcomparisionwithusername:"",
   duplicatepassord:"",expiryDate:"",expiry:""
  }
  customArray: any[] = []; // <-- initialize here
  buttonIdList = []


  constructor( private localStorageSettings: LocalStorageSettingsService, private spinner: NgxUiLoaderService,
      private snackBar: MatSnackBar,private dialog: MatDialog,private commonService:CommonService, private userRoutingModule: UserRoutingModule,
           private reportLinkService:ReportlinksserviceService) {
        this.components = {
        
              buttonRenderer: Actionbutton,
        
            };
       }

  ngOnInit(): void {
    let screenPath = this.userRoutingModule.print(this.constructor.name);
    console.log(screenPath);
    this.reportLinkService.screenoperationspermission(screenPath,this.localStorageSettings.getSettings('UserId')).subscribe(res => {
      console.log(res);
      let responsedata: any ;
      responsedata = res;
      for (let i = 0; i <responsedata.length ; i++) {
        
       this.buttonIdList.push(responsedata[i].buttonId); // Add buttonId to the list
       }
       
       this.buttonIdList.push('screen');
       console.log('Button ID List:', this.buttonIdList);
       const buttons = document.querySelectorAll('button'); // Select all buttons in the DOM
       buttons.forEach(button => {
       const buttonId = parseInt(button.getAttribute('id'), 10); // Get the button's id
       if (!isNaN(buttonId)) { // Only process buttons with a valid numeric id
         if (!this.buttonIdList.includes(buttonId)) {
             button.setAttribute('disabled', 'true'); // Disable the button
         } else {
             button.removeAttribute('disabled'); // Enable the button
         }
       }
       });
 
     });
    this.defaultColDef = {
filterParams: {
        maxNumConditions: 2,
        numAlwaysVisibleConditions: 2,
        defaultJoinOperator: 'OR'
      },

      sortable: true,

      resizable: true,

      filter: true

    };
    
    this.columnDefs = [
      {
        headerName: 'Action',
        filter: false,
        cellRenderer: 'buttonRenderer',
        cellRendererParams: {
           values: this.buttonIdList,
          edit: this.editIcon.bind(this),
           delete: this.deleteIcon.bind(this)
        },
        pinned: 'left',
        lockPinned: true,
        width: 150,
      },

      {
        headerName: 'Id',
        headerTooltip: 'Id',
        tooltipValueGetter: (params) =>
          'Id : ' + params.value,
        field: 'id',
        filter: 'agTextColumnFilter',
        width: 180,
      },
      // {
      //   headerName: 'Disable All Rules',
      //   headerTooltip: 'Disable All Rules',
      //   tooltipValueGetter: (params) =>
      //     'Disable All Rules : ' + params.value,
      //   field: 'disableallrules',
      //   filter: 'agTextColumnFilter',
      //   width: 180,
      // }, 
       {
       headerName: 'Company Name',
        headerTooltip: 'Company Name',
        tooltipValueGetter: (params) => 'Company Name : '+ params.value,
        field:'companyname',
        filter:'agTextColumnFilter',
        width:180,
      },
      {
        headerName: 'Retry Limits',
        headerTooltip: 'Retry Limits',
        tooltipValueGetter: (params) =>
          'Retry Limits : ' + params.value,
        field: 'resetlimit',
        filter: 'agTextColumnFilter',
        width: 180,
      },

      {
        headerName: 'Last Passwords Comparision',
        headerTooltip: 'Last Passwords Comparision',
        tooltipValueGetter: (params) =>
          'Last Passwords Comparision : ' + params.value,
        field: 'lastpasswordchecking',
        filter: 'agTextColumnFilter',
        width: 180,
      },
      // {
      //   headerName: 'Master ByPass',
      //   headerTooltip: 'Master ByPass',
      //   tooltipValueGetter: (params) => 'Master ByPass : '+ params.value,
      //   field:'masterbypass',
      //   filter:'agTextColumnFilter',
      //   width:650,
      // },
      {
       headerName: 'Password Comparision with Username',
        headerTooltip: 'Password Comparision with Username',
        tooltipValueGetter: (params) => 'Password Comparision with Username : '+ params.value,
        field:'passwrodcomparisionwithusername',
        filter:'agTextColumnFilter',
        width:180,
      },
        {
       headerName: 'Password Expiry Period',
        headerTooltip: 'Password Expiry Period',
        tooltipValueGetter: (params) => 'Password Expiry Period : '+ params.value,
        field:'passwordexpirycycle',
        filter:'agTextColumnFilter',
        width:180,
      },
      {
       headerName: 'Lockout Enabled',
        headerTooltip: 'Lockout Enabled',
        tooltipValueGetter: (params) => 'Lockout Enabled : '+ params.value,
        field:'lockoutenabled',
        filter:'agTextColumnFilter',
        width:180,
      },
      {
       headerName: 'Lockout Value',
        headerTooltip: 'Lockout Value',
        tooltipValueGetter: (params) => 'Lockout Value : '+ params.value,
        field:'lockoutvalue',
        filter:'agTextColumnFilter',
        width:180,
      },
      {
       headerName: 'Lockout Unit',
        headerTooltip: 'Lockout Unit',
        tooltipValueGetter: (params) => 'Lockout Unit : '+ params.value,
        field:'lockoutUnit',
        filter:'agTextColumnFilter',
        width:180,
      },
        {
       headerName: 'Status',
        headerTooltip: 'Status',
        tooltipValueGetter: (params) => 'Status : '+ params.value,
        field:'status',
        filter:'agTextColumnFilter',
        width:100,
      }
     
      
    ];
      this.rowClassRules = {
      'rowBackgroundColor': function (params) {
        var numSickDays = params.node.data.status;
        return numSickDays === "No" || numSickDays === null;
      },
    };
     this.backgroundColorButton = this.localStorageSettings.getSettings('ColorA');
     this.backgroundColorScreen = this.localStorageSettings.getSettings("ColorD");
  }

  
  onPaginationChangedReturn() {
    if (this.gridAPI) {
      this.lastPage = this.gridAPI.paginationIsLastPageFound();
      this.currentPage = this.gridAPI.paginationGetCurrentPage() + 1;
      this.nextPage = this.gridAPI.paginationGetCurrentPage() + 1 + 1;
      this.nextPagePlusOne =
        this.gridAPI.paginationGetCurrentPage() + 1 + 1 + 1;
      this.totalPages = this.gridAPI.paginationGetTotalPages();
    }
  }

  //excel export function
  onBtExport() {

    this.gridAPI.exportDataAsCsv();

  }

  //pagination code
  onPaginationChanged() {

    if (this.gridAPI) {

      this.lastPage = this.gridAPI.paginationIsLastPageFound();

      this.currentPage = this.gridAPI.paginationGetCurrentPage() + 1;

      this.nextPage = this.gridAPI.paginationGetCurrentPage() + 1 + 1;

      this.nextPagePlusOne = this.gridAPI.paginationGetCurrentPage() + 1 + 1 + 1;

      this.totalPages = this.gridAPI.paginationGetTotalPages();

    }

  }

  //this function is for going to the given page number
  onSearchChange(searchValue: number) {

    this.gridAPI.paginationGoToPage(searchValue - 1);

  }

  // below function is for changing the no of rows per page
  onPageSizeChanged() {

    var value = this.pageSize;

    this.gridAPI.setGridOption('paginationPageSize', Number(value));

  }

  // below function is for going to next page
  async onBtNext() {

  

    this.gridAPI.paginationGoToNextPage();

  }

  // below function for going to previous page
  async onBtPrevious() {

    this.gridAPI.paginationGoToPreviousPage();

  }

  // below function for going to first page
  onBtFirst() {

    this.gridAPI.paginationGoToFirstPage();

  }

  // below function for going to last page
  onBtLast() {

    this.gridAPI.paginationGoToLastPage();

  }

  //pagination code ends

  // below function is to load the ag grid
  async onGridReady(params) {
    this.gridAPI = params.api;
    this.getData = [];
    this.gridColumnAPI = params.columnApi;
    this.spinner.start()
    this.retrieve()
    this.spinner.stop()

  }

  openSaveForm(){
    console.log()
      let dialogRef = this.dialog.open(PasswordConfigurationPopUpComponent, {
          panelClass: 'custom-dialog-container-materialFulfilment',
          width: '80%',
          autoFocus: false,
          // data: { edata: obj},
          disableClose: true,
        });
         dialogRef.afterClosed().subscribe(result=>{
          this.retrieve()
        })
    //  this.commonService.insertPasswordPolicies(this.passwordPolicy)
    // .subscribe({
    //   next: (res) => {
    //     this.spinner.stop();
    //     this.snackBar.open('Password policy saved successfully', '', { duration: 3000 });
    //     // Optionally refresh data here
    //   },
    //   error: (err) => {
    //     this.spinner.stop();
    //     this.snackBar.open('Failed to save password policy', '', { duration: 3000 });
    //     console.error(err);
    //   }
    // });
   
  }

  cancel(){

  }
  editIcon(e){
    console.log("inside edit")
     let rowData = e.rowData;
    
        console.log(rowData);
    
        var obj = {
          "id":e.rowData.id,
          "disableallrules":e.rowData.disableallrules,
          "resetlimit":e.rowData.resetlimit,
          "lastpasswordchecking":e.rowData.lastpasswordchecking,
          "passwrodcomparisionwithusername":e.rowData.passwrodcomparisionwithusername,
          "duplicatepassord":e.rowData.duplicatepassord,
          "lockoutenabled":e.rowData.lockoutenabled,
          "lockoutvalue":e.rowData.lockoutvalue,
          "lockoutUnit":e.rowData.lockoutUnit,
          "passwordexpirycycle":e.rowData.passwordexpirycycle,
          "companyname":e.rowData.companyname
          
        }
        console.log(obj)
        let dialogRef = this.dialog.open(PasswordConfigurationPopUpComponent, {
          panelClass: 'custom-dialog-container-materialFulfilment',
          width: '80%',
          autoFocus: false,
          data: { edata: obj},
          disableClose: true,
        });
    
        dialogRef.afterClosed().subscribe(result=>{
          this.retrieve()
        })
  }
  deleteIcon(e){
    console.log("inside delete")
    console.log(e.rowData)
    console.log(e.rowData.id)
    if(e.rowData.status === 'No'){
       this.snackBar.open("Already the record is deleted", 'OK', {duration: 5000});
       return
    }
    if (confirm("Are you sure you want to delete password configuration ?")) {
    this.spinner.start()
    this.commonService.deletePasswordPolicies(e.rowData.id).subscribe(response => {
      if (response.error == true) {
        console.log('inside error');
        console.log(response);
        
        this.spinner.stop();
        this.snackBar.open(response.statusMessage, 'OK', {duration: 5000});
        
      } else {
        //  this.customArray = this.customArray.filter(item => item.id !== e.rowData.id);
        // // this.customArray = updatedRowData; // Update the array
        // this.gridAPI.setGridOption('rowData', this.customArray);
        this.retrieve()
        this.spinner.stop();
        this.snackBar.open(response.statusMessage, 'OK', {duration: 50000});
      }
    });
  }
  }
  
  retrieve(){
    this.spinner.start()
      this.commonService.retrieveDetails().subscribe(response => {
        console.log("Inside retrieve")
        console.log(response)
       

      if (response.error == true) {
        console.log('inside error');
        console.log(response);
        this.spinner.stop();
       
        
        // this.snackBar.open(response.statusMessage, 'OK', {duration: 5000});
        this.gridAPI.setGridOption('rowData', response);
      } else {
         for(const item of response){
          const objectsarray= {
            id: item.id,
            disableallrules:item.disableallrules
          }
          this.customArray.push(objectsarray)
          console.log(this.customArray)
        }
         const sortedData = response.sort((a, b) => {
        // Step 1: push "No" to bottom
        if (a.status === "No" && b.status !== "No") return 1;
        if (a.status !== "No" && b.status === "No") return -1;
        // Step 2: for remaining, sort descending by id (or any other field)
        return b.id - a.id; // descending
      });
        this.gridAPI.setGridOption('rowData', sortedData)
        this.spinner.stop();
        
        // this.snackBar.open(response.statusMessage, 'OK', {duration: 50000});
      }
    });
  }
}
